import React, { useState } from "react";
import { DeleteOutlined, DownloadOutlined } from "@ant-design/icons";
import Lightbox from "./Lightbox";
import "./ImageGallery.css";
import { Skeleton } from "antd";
import { downloadImage } from "../../services/firebaseService/endPoints/clubAdmin/gallery";
import ChantPopConfirm from "../ChantTooltip/ChantPopConfirm";

const ImageGallery = ({ images, deletingImageId, deleteLoading, loading }) => {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  // Handle image deletion - close lightbox if current image is deleted
  const handleImageDelete = (imageId) => {
    const currentImage = images[currentImageIndex];
    if (currentImage && currentImage.id === imageId) {
      setLightboxOpen(false);
    }
  };

  const handleDownload = (imgsrc) => {
    downloadImage(imgsrc);
  };

  const renderGalleryItem = (image, index) => {
    const isDeleting = deleteLoading && deleteLoading[image.id];

    const isAnyDeleting = Object.values(deleteLoading).some((value) => value);

    return (
      <div key={image.id} className="gallery-item-container">
        {isDeleting ? (
          <div
            className="gallery-item-skeleton"
            style={{ cursor: "not-allowed" }}
          >
            <Skeleton.Node active={isDeleting}>
              <DeleteOutlined style={{ fontSize: 40, color: "#bfbfbf" }} />
            </Skeleton.Node>
          </div>
        ) : (
          <div
            className="gallery-item"
            style={{ cursor: isAnyDeleting ? "not-allowed" : "pointer" }}
            onClick={() => !isAnyDeleting && openLightbox(index)}
          >
            <img
              src={image.src}
              alt={`gallery img ${index + 1}`}
              className="gallery-image"
            />
            <div className="image-overlay">
              <p className="upload-date">{image?.tags?.[0]?.title}</p>
            </div>
            <div className="img-overlay-actions">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDownload(image.srcLg || image.src);
                }}
                className="download-button"
              >
                <DownloadOutlined />
              </button>

              <ChantPopConfirm
                title="Delete image?"
                onConfirm={(e) => {
                  e.stopPropagation();
                  if (image.onDelete) {
                    image.onDelete();
                    handleImageDelete(image.id);
                  }
                }}
                onCancel={(e) => e.stopPropagation()}
                okButtonProps={{
                  loading: deletingImageId === image.id,
                  disabled: deletingImageId === image.id,
                }}
                cancelButtonProps={{
                  disabled: deletingImageId === image.id,
                }}
                okText="Yes"
                cancelText="No"
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="delete-button"
                >
                  <DeleteOutlined />
                </button>
              </ChantPopConfirm>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderSkeletonItems = () => {
    return Array.from({ length: 10 }, (_, index) => (
      <div key={`skeleton-${index}`} className="gallery-item-container">
        <div className="gallery-item-skeleton">
          <Skeleton.Image active />
        </div>
      </div>
    ));
  };

  return (
    <div className="gallery-container">
      <div className="gallery-grid">
        {loading ? renderSkeletonItems() : images.map(renderGalleryItem)}
      </div>
      {lightboxOpen && (
        <Lightbox
          images={images}
          lightboxOpen={lightboxOpen}
          setLightboxOpen={setLightboxOpen}
          currentImageIndex={currentImageIndex}
          deletingImageId={deletingImageId}
          setCurrentImageIndex={setCurrentImageIndex}
        />
      )}
    </div>
  );
};

export default ImageGallery;
